<template>
  <div id="map">
    <yandex-map style="width: 100%; height: 500px;" :coords="center" :zoom="10"
                :controls="['fullscreenControl', 'zoomControl', 'typeSelector']">
      <ymap-marker :coords="center" marker-id="marker"/>
    </yandex-map>
  </div>
</template>

<script>
export default {
  name: "InitiativeYandexMap",
  props: {
    latLong: {
      type: Array,
      required: true
    }
  },
  computed: {
    center() {
      return this.latLong
    }
  },
}
</script>

<style scoped>

</style>